type PaysafeCustomer = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dateOfBirth?: {
    day: number;
    month: number;
    year: number;
  };
  merchantCustomerId: string;
};

type PaysafeBillingAddress = {
  street: string;
  city: string;
  zip: string;
  country: string;
  state?: string;
};

type PaysafeThreeDS = {
  merchantUrl: string;
  useThreeDSecureVersion2: boolean;
  authenticationPurpose: 'PAYMENT_TRANSACTION';
  deviceChannel: 'BROWSER' | 'APP' | string;
  requestorChallengePreference: 'CHALLENGE_MANDATED' | 'NO_PREFERENCE' | string;
  transactionintent: 'GOODS_OR_SERVICE_PURCHASE' | 'CHECK_ACCEPTANCE' | string;
  messageCategory: 'PAYMENT' | 'NON_PAYMENT' | string;
};

type PaysafePaymentMethodDetails = {
  card: {
    accountId: string;
  };
};

export type PaysafeSetupConfig = {
  initializationTimeout: number;
  currency: string;
  amount: number;
  merchantRefNum: string;
  customer: PaysafeCustomer;
  displayPaymentMethods: string[];
  paymentMethodDetails: PaysafePaymentMethodDetails;
  environment: 'LIVE' | 'TEST';
  billingAddress: PaysafeBillingAddress;
  simulator?: 'EXTERNAL' | 'INTERNAL' | string;
  threeDs?: PaysafeThreeDS;
};

type PaysafeSetupCallback = (
  instance: any,
  error: any,
  result: { paymentHandleToken?: string } | null,
) => void;

export enum StageOfExit {
  NOT_STARTED = 'PAYMENT_HANDLE_NOT_CREATED',
  IN_REDIRECT = 'PAYMENT_HANDLE_REDIRECT',
  AFTER_REDIRECT = 'PAYMENT_HANDLE_PAYABLE',
}

type PaysafeStageCallback = (stage: StageOfExit, expired: boolean) => void;

type PaysafeCheckoutSetup = (
  apiKey: string,
  config: PaysafeSetupConfig,
  onPaymentHandleCreated: PaysafeSetupCallback,
  onStageChange: PaysafeStageCallback,
) => void;

export interface PaySafeCheckout {
  checkout: {
    setup: PaysafeCheckoutSetup;
  };
}
